import application from 'application/application';

let env = 'development';

if (/homologacao/.test('#{api-hostname}#')) env = 'homologation';

if (!/homologacao/.test('#{api-hostname}#') && !/dev/.test('#{api-hostname}#'))
	env = 'production';

application.value('environment', {
	name: env,
	version: '90.04'
});
